export const SavingFlagConstants = {
  quickQuote: 'isQuickQuoteSaving',
  coverages: 'isCoveragesSaving',
  endorsements: 'isEndorsementsSaving',
  claims: 'isClaimsSaving',
  property: 'isPropertySaving',
  applicant: 'isApplicantSaving',
  notes: 'isNotesSaving'
};